module.exports = __webpack_public_path__ + "static/Załącznik nr 3 do REGULAMINU-c22e2a592c31bae4ba09040cd970360a.pdf";